/** Google Apps Script web-app URLs for form submissions */
export const CONTACT_FORM_URL =
  'https://script.google.com/macros/s/AKfycbz0l1z7C1mmwm4ACnmAsRk6GtdnUR-ZXq-Jf-FRyxOem6HAF8piOlOl16AK8Kl5mR04Zw/exec';

export const REGISTER_FORM_URL =
  'https://script.google.com/macros/s/AKfycbyXWwMcv1aAweTsiqnYBqtwO41_GFESIs8__nYu2_-CUdUCY5TadE0h7THbep8-JAg6YQ/exec';

/** Paste URL after deploying google-apps-script/whatsapp-form.gs (or unified-form.gs with FormType whatsapp). */
export const WHATSAPP_FORM_URL = '';

export const CONTACT_SUCCESS_MESSAGE =
  'Thank you for contacting us. We will get back to you soon.';

export const REGISTER_SUCCESS_MESSAGE = 'Registration Successful...';

export const WHATSAPP_SUCCESS_MESSAGE =
  'Thank you! We will reach out to you soon.';

export function isFormScriptError(message) {
  return Boolean(message && /^(Mail error|Missing|Invalid|Wrong form)/i.test(message));
}

/** Build contact payload — works with unified GAS script AND legacy register-only script. */
export function buildContactFormPayload(getFormField, form) {
  const name = getFormField(form, 'name');
  const email = getFormField(form, 'email');
  const graduationYear = getFormField(form, 'graduationYear');
  const discipline = getFormField(form, 'discipline');
  const reason = getFormField(form, 'reason') || 'General inquiry';
  const message = getFormField(form, 'query');

  const legacyQuery = [
    '=== LITAANA CONTACT FORM ===',
    `Reason: ${reason}`,
    graduationYear ? `Graduation Year: ${graduationYear}` : '',
    discipline ? `Discipline: ${discipline}` : '',
    '',
    'Message:',
    message,
  ].filter(Boolean).join('\n');

  return {
    FormType: 'contact',
    Name: `[CONTACT] ${name}`,
    Email: email,
    Reason: reason,
    GraduationYear: graduationYear,
    Discipline: discipline,
    Message: message,
    Query: legacyQuery,
  };
}

export function buildWhatsappFormPayload(email) {
  return {
    FormType: 'whatsapp',
    Email: email.trim(),
  };
}
